/* eslint-disable react-hooks/exhaustive-deps */
import React,{useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import '../assets/styles/modal.scss'
import logo from '../assets/logo.svg';
import closeIcon from '../images/icons/Icon2.png'
import { useState } from 'react';
import { emailRegex } from '../utils/commonFunctions';
import { UserEndpoint,EmployeeEndpoint } from '../utils/axios';

export const ForgotPasswordModal = (props) => {
    const { t } = useTranslation();

    const [ email, setEmail ] = useState('');
    const [ APIResp, setAPIResp ] = useState({ isExecuted: false, success: false, message: '' });
    const [errors, setErrors] = useState({ email: '' });
    
    const onCloseDialog = () => {
        setEmail('');
        setAPIResp({ isExecuted: false, success: false, message: '' });
        setErrors({ email: '' })
        props.clearForgotPwd();
    }

useEffect(() => {
  if(email.length && !emailRegex.test(email) && props.data.loginMode){
        setErrors({...errors, email: 'E-mail is invalid!'});
                }
  return () => {
   setErrors(prevErrors => ({ ...prevErrors, email: '' }));
  }
}, [email])

    const handleForgotPwdForm = async (e) => {
        e.preventDefault();
        setAPIResp({ isExecuted: false, success: false, message: '' });

        const submitBtnObj = document.getElementsByClassName('done-button')[0];
      
            if ( !email ) {
                setErrors({...errors, email: props.data?.loginMode?'Enter email':'Enter employee code'});
                return false;
            }
            else if(props.data?.loginMode) {
                if(!emailRegex.test(email)){
                    setErrors({...errors, email: 'E-mail is invalid!'});
                    return;
                }
            }            
            const payload = {
                username: email
            };
    
    
            submitBtnObj.setAttribute('disabled', 'true');
            const Domain=props.data.loginMode?UserEndpoint:EmployeeEndpoint;
            const url=props.data.loginMode?'password/reset':'resetPassword';
            await Domain.post(url, payload)
            .then( (resp) => {
                submitBtnObj.removeAttribute('disabled');
                setAPIResp({ isExecuted: true, success: true, message:resp?.msg||resp?.message || 'We have sent reset password details to your registered email.' }); //resp.msg
                setTimeout( () => {
                    onCloseDialog();
                }, 2500 );
            })
            .catch( (err) => {
                submitBtnObj.removeAttribute('disabled');
    
                let statusObj = JSON.parse(err.message);
                let msg = 'Error occured while submitting your request.';
                if (statusObj.status === 400) {
                    msg = statusObj.data?.msg||statusObj.data?.message;
                }
                setAPIResp({ isExecuted: true, success: false, message: msg });
            });
    
            return false;
        
    };
    const onEmailChange = (e) => {
        setEmail(e.target.value);

        setAPIResp({ isExecuted: false, success: false, message: '' });

        if ( !e.target.value ) {
            setErrors({...errors, email: props.data.loginMode?'Enter email':'Enter employee code'});
        } else {
            setErrors({...errors, email: ''});
        }
    }

    return <>
    { props.data.show === true && !props.data?.loginMode ?
        <>
            <div className="overlay2" role="dialog">
                <div className="dialog2 sm-scrollbar">
                    <form onSubmit={ (e) => handleForgotPwdForm(e)}>

                        <div className="dialog__header pt-4">
                            <img className="modal__close_icon" alt='Close' src={closeIcon} onClick={ () => onCloseDialog() } />
                            <h2 className="dialog__title subheading-text-medium fontMedium">{t('pages.loginContent.forgotPasswordDg.titleEmployee')}</h2>
                            <hr />
                        </div>

                        <div className="dialog__content mt-0">
                            <div className="dialog__body_container flexRow justifyContentSpaceBetween flexWrap">

                                <div className="flexCol justifyContentSpaceEvenly">
                                     <div className='flexRow justifyContentCenter alignItemsCenter margBottom6'><img alt='logo' src={logo} /></div>
                                    <div className=" dialog__container_item input-container">
                                        <div className="dialog__description">
                                            <input type="text" className="edit-input" name="email" attribute="email" placeholder={t('pages.loginContent.forgotPasswordDg.enterEmployeeCode')} value={email} onChange={ (e) => onEmailChange(e) } />
                                            {errors.email ? <>
                                                <div className='validationMsgDiv error'>{errors.email}</div>
                                            </> : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                        </div>

                            {APIResp.isExecuted === true ?
                            <>
                                <div className={ "dialog__statusBlock mt-0 " + ( !APIResp.success ? 'alert_error' : 'alert_success') }>
                                { APIResp.message }
                                </div>
                            </> : null }
                            
                        <div className="dialog__footer flexRow justifyContentSpaceEvenly pt-2 mb-4">
                            <button type="submit" className="done-button">{t('buttons.resetPassword')}</button>
                        </div>
                    </form>
                </div>
            </div>
        </>:props.data.show === true && props.data?.loginMode ?
        <>
        <div className="overlay2" role="dialog">
                <div className="dialog2 sm-scrollbar">
                    <form onSubmit={ (e) => handleForgotPwdForm(e)}>

                        <div className="dialog__header pt-4">
                            <img className="modal__close_icon" alt='Close' src={closeIcon} onClick={ () => onCloseDialog() } />
                            <h2 className="dialog__title subheading-text-medium fontMedium">{t('pages.loginContent.forgotPasswordDg.titleAdmin')}</h2>
                            <hr />
                        </div>

                        <div className="dialog__content mt-0">
                            <div className="dialog__body_container flexRow justifyContentSpaceBetween flexWrap">

                                <div className="flexCol justifyContentSpaceEvenly ">
                                       <div className='flexRow justifyContentCenter alignItemsCenter margBottom6'><img alt='logo' src={logo} /></div>
                                    <div className=" dialog__container_item input-container">
                                        <div className="dialog__description">
                                            <input type="text" className="edit-input" name="email" attribute="email" placeholder={t('pages.loginContent.forgotPasswordDg.enterUserEmailAdmin')} value={email} onChange={ (e) => onEmailChange(e) } />
                                            {errors.email ? <>
                                                <div className='validationMsgDiv error'>{errors.email}</div>
                                            </> : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                        </div>

                            {APIResp.isExecuted === true ?
                            <>
                                <div className={ "dialog__statusBlock mt-0 " + ( !APIResp.success ? 'alert_error' : 'alert_success') }>
                                { APIResp.message }
                                </div>
                            </> : null }
                            
                        <div className="flexRow justifyContentCenter alignItemsCenter pt-2 mb-4">
                            <button type="submit"  className="done-button">{t('buttons.resendPassword')}</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
        :<></>
    } 
  </>  
};